import { toast } from "sonner";
import { PageTitle, Card, Btn } from "./ui";

const Field = ({ label, testId, textarea, ...props }) => (
  <label className="block">
    <span className="text-sm font-semibold mb-1 block">{label}</span>
    {textarea
      ? <textarea rows={2} {...props} data-testid={testId} className="w-full px-3 py-2 border border-[#E2E2E2] text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#111111]" />
      : <input {...props} data-testid={testId} className="w-full h-10 px-3 border border-[#E2E2E2] text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#111111]" />}
  </label>
);

export default function Seo() {
  const save = (e) => { e.preventDefault(); toast.success("SEO iestatījumi saglabāti (DEMO)"); };
  return (
    <div data-testid="admin-seo">
      <PageTitle>SEO iestatījumi</PageTitle>
      <form onSubmit={save} className="space-y-4 max-w-3xl">
        <Card className="p-5 space-y-4">
          <h2 className="text-sm font-bold uppercase tracking-widest">Sākumlapa</h2>
          <Field label="Meta virsraksts" defaultValue="E-Commerce DEMO — saimniecības un higiēnas preces vairumā un mazumā" testId="seo-home-title" />
          <Field label="Meta apraksts" textarea defaultValue="Interneta veikala demonstrācija: 5000+ preces uzņēmumiem un mājsaimniecībām. Ātra piegāde, B2B cenas, droši maksājumi." testId="seo-home-desc" />
        </Card>
        <Card className="p-5 space-y-4">
          <h2 className="text-sm font-bold uppercase tracking-widest">Tehniskie iestatījumi</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Kanoniskais domēns" defaultValue="https://www.ecommercedemo.lv" testId="seo-canonical" />
            <Field label="Sitemap URL" defaultValue="/sitemap.xml (automātiski atjaunots)" testId="seo-sitemap" />
          </div>
          <div className="flex flex-wrap gap-5 text-sm font-semibold">
            <label className="flex items-center gap-2"><input type="checkbox" defaultChecked className="accent-[#D0121A]" data-testid="seo-friendly-urls" /> Draudzīgie URL</label>
            <label className="flex items-center gap-2"><input type="checkbox" defaultChecked className="accent-[#D0121A]" data-testid="seo-schema" /> Schema.org strukturētie dati</label>
            <label className="flex items-center gap-2"><input type="checkbox" defaultChecked className="accent-[#D0121A]" data-testid="seo-og" /> Open Graph / sociālie tagi</label>
            <label className="flex items-center gap-2"><input type="checkbox" className="accent-[#D0121A]" data-testid="seo-noindex" /> noindex (izstrādes režīms)</label>
          </div>
        </Card>
        <Btn type="submit" variant="red" className="px-8 py-3 text-sm" data-testid="seo-save">Saglabāt SEO iestatījumus</Btn>
      </form>
    </div>
  );
}
